import {deserialize, deserializeAs} from "cerialize";

export class Document {

  @deserialize
  id: number;

  @deserialize
  nom: string;

  @deserialize
  societe: string;

  @deserializeAs('sharing_signature')
  sharingSignature: string;

  @deserialize
  email: string;

  @deserialize
  decision: string;

  @deserialize
  fichier: any;

  @deserialize
  dossier: any;

  @deserialize
  roles: string[] = [];

  @deserializeAs(Date,'updated_at')
  updatedAt: Date = null;

  @deserializeAs(Date,'created_at')
  createdAt: Date = null;

  @deserializeAs(Date,'date_information_decision')
  dateInformationDecision: Date = null;

  @deserializeAs(Date,'date_acceptation_decision')
  dateAcceptationDecision: Date = null;
}
